import {useState} from "react"

import {ChatbotEvent} from "@proto/chatbot/v1alpha/chatbot"
import {Input} from "@/components/ui/input"
import ProcessingIndicator from "@/components/ui/ProcessingIndicator"
import {useWebsocket} from "@/hooks/useWebsocket"
import {UserInputArrowIcon} from "./icons"

interface IProps {
    enabled: boolean
}

const UserInput = ({enabled}: IProps) => {
    const [userInput, setUserInput] = useState<string>("")
    const [placeholder, setPlaceholder] = useState<string>("I'm looking for...")
    const {send, addMessage, isConnected} = useWebsocket()

    const sendMessage = () => {
        if (userInput.length == 0) {
            return
        }
        const um: ChatbotEvent = {
            type: "user",
            message: userInput,
            id: "",
            clientId: "",
        }
        send(JSON.stringify(um))
        addMessage(um)
        setUserInput("")
        setPlaceholder("")
    }

    const onKeyUpHandler = (e: {preventDefault: () => void; key: string}) => {
        e.preventDefault()
        if (e.key === "Enter") {
            sendMessage()
        }
    }

    if (enabled && isConnected) {
        return (
            <div className="flex mr-4 ml-4">
                <Input
                    className="rounded-[20px] bg-white text-foreground p-[10px] pl-[14px]"
                    type="text"
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyUp={onKeyUpHandler}
                    placeholder={placeholder}
                />

                {userInput.length > 0 ? (
                    <div className="mt-[7px] size-6 -ml-10 cursor-pointer" onClick={sendMessage}>
                        <UserInputArrowIcon />
                    </div>
                ) : (
                    <div className="mt-[7px] size-6 -ml-10 opacity-25">
                        <UserInputArrowIcon />
                    </div>
                )}
            </div>
        )
    } else {
        return (
            <div className="flex mr-4 ml-4">
                <Input className="rounded-[20px] bg-white text-foreground p-[10px] pl-[14px]" disabled type="text" value={userInput} />
                <div className="absolute top-[27px] left-[25px] w-full">
                    <ProcessingIndicator />
                </div>
            </div>
        )
    }
}

export default UserInput
